<template>
  <div>
    <div class="row m-b-20 m-t-20">
      <div class="col-md-12 p-0">
        <table class="table_beauty concurrency-matrix">
          <thead>
            <tr>
              <th class="col-md-1 p-0 p-r-10 text-right">&nbsp;</th>
              <th class="col-md-1 p-0 p-r-10 text-right" />
              <th v-for="hour in detailedHours" class="text-right p-0 p-r-10">
                {{ hour }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-right p-0 p-r-10 min-width-40" />
              <td class="p-0 min-width-40" />
              <td v-for="(hour, index) in hours" class="p-0 text-right">
                <input
                  type="number"
                  :tabindex="index + 2"
                  :value="allHours[index]"
                  min="0"
                  placeholder="∞"
                  class="form-control"
                  @input="allHoursUpdate(hour, $event)"
                />
              </td>
            </tr>
            <tr v-for="(day, dayIndex) in daysOfWeek">
              <td class="text-right p-0 p-r-10">
                {{ day }}
              </td>
              <td class="p-0 text-center">
                <input
                  type="number"
                  tabindex="1"
                  :value="allDays[dayIndex]"
                  min="0"
                  placeholder="∞"
                  class="form-control"
                  @input="allDaysUpdate(dayIndex, $event)"
                />
              </td>
              <td v-for="(hour, hourIndex) in hours" class="p-0 text-center">
                <input
                  type="number"
                  :tabindex="hourIndex + 2"
                  :value="matrix[dayIndex][hour]"
                  min="0"
                  placeholder="∞"
                  class="form-control"
                  @input="matrixModified(dayIndex, hour, $event)"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '@/i18n';
import messages from './locales';

export default {
  name: 'HourlyDayMatrix',
  props: {
    matrix: {
      required: true,
      type: Array,
    },
    allTime: {
      type: Number,
      default: undefined,
    },
    allDays: {
      type: Array,
      default: undefined,
    },
    allHours: {
      type: Array,
      default: undefined,
    },
  },
  computed: {
    detailedHours: function () {
      const self = this;
      return this.hours.map(function (i) {
        return self.formatHour(i);
      });
    },
  },
  beforeCreate: function () {
    this.daysOfWeek = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    this.hours = _.range(24);
    this.oldValue = undefined;
  },
  methods: {
    formatHour: function (input) {
      if (input === 0) {
        return '12 AM';
      } else if (input === 12) {
        return input + ' PM';
      } else if (input > 12) {
        var newHour = input - 12;
        return newHour + ' PM';
      } else {
        return input + ' AM';
      }
    },
    allHoursUpdate: function (hour, $event) {
      var value = parseInt($event.target.value);
      if (isNaN(value)) value = undefined;
      this.$emit('matrixHourNeedsUpdate', { hour, value });
    },
    allDaysUpdate: function (day, $event) {
      var value = parseInt($event.target.value);
      if (isNaN(value)) value = undefined;
      this.$emit('matrixDayNeedsUpdate', { day, value });
    },
    matrixModified: function (day, hour, $event) {
      if(!isNaN($event?.target?.value)) {
        var value = parseInt($event.target.value);
        if (isNaN(value)) value = undefined;
        this.oldValue = value;
        this.$emit('matrixNeedsUpdate', { day, hour, value });
      }
    }
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>